import React from 'react';
import PropTypes from 'prop-types';
import { generateGridStyles } from '../components/helpers';
import { generateUniqueId } from '../../../common/utils/utils';

const Date = ({ getHandlers, val, gridStyles, name }) => {
    const { stylers, classes, existSt } = generateGridStyles(gridStyles, name);
    return (
        <div {...getHandlers(false)} className={classes.wrapper} style={stylers.wrapper}>
            <p className={classes.p} style={existSt('p') || { color: 'var(--darkColor)' }} key={generateUniqueId()}>
                {typeof val === 'object'
                    ? Object.keys(val).map((item, idx) => (
                          <React.Fragment key={`date${idx}`}>
                              {val[item]}
                              {idx === 0}
                          </React.Fragment>
                      ))
                    : val}
            </p>
        </div>
    );
};
Date.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    name: PropTypes.string,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string])
};
export default Date;
